import React from 'react';
import { AllieIconProps } from '../../../components';
/* eslint-disable max-len */
export const MenuBellSelectedMobileApp: React.FC<AllieIconProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path
        d="M21 9.80016C21 7.81988 20.2625 5.9207 18.9497 4.52043C17.637 3.12016 15.8565 2.3335 14 2.3335C12.1435 2.3335 10.363 3.12016 9.05025 4.52043C7.7375 5.9207 7 7.81988 7 9.80016C7 18.5113 3.5 21.0002 3.5 21.0002H24.5C24.5 21.0002 21 18.5113 21 9.80016Z"
        fill={props.color || '#131316'}
        stroke="#131316"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0184 24.5C15.8132 24.8536 15.5188 25.1471 15.1646 25.3511C14.8104 25.5551 14.4088 25.6625 14 25.6625C13.5912 25.6625 13.1896 25.5551 12.8354 25.3511C12.4812 25.1471 12.1868 24.8536 11.9817 24.5"
        stroke="#131316"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
